import axios from "axios";

axios.interceptors.request.use(
  (config) => {
    if (localStorage.getItem("accessToken")) {
      config = {
        ...config,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          ...config.headers,
        },
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
